import { useRef } from 'react';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { LocalAllowListForm } from '#components/patterns/config-overrides/forms/LocalAllowForm.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import type { LocalAllowRule } from '#dn-types/config-override.ts';

type Props = {
  onCancel: () => void;
  onSave: (values: LocalAllowRule) => void;
  value?: LocalAllowRule;
  cidrValidation: (value: string) => string | true;
};

export function LocalAllowModal({ onSave, onCancel, cidrValidation, value }: Props) {
  const modalRef = useRef(null);

  return (
    <Modal isOpen={true} onClose={onCancel} ref={modalRef}>
      <ModalHeader>{value ? 'Change local allow row' : 'Add to local allow list'}</ModalHeader>
      <ModalBody>
        <LocalAllowListForm defaultValues={value} onSave={onSave} cidrValidation={cidrValidation} />
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <Button type="submit" form="lighthouse.local_allow_list-form">
              {value ? 'Save' : 'Add'}
            </Button>
          }
          secondaryButton={
            <Button variant="link" onClick={onCancel}>
              Cancel
            </Button>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
